import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { PaymentGateway } from "../../../components";
import { GeneralContext } from "../../../contexts/general.context";
import { NCETranscriptRequestContext } from "../../../contexts/NCETranscriptRequest";

export const PaymentModal = ({ onClose, modal }) => {
  const navigate = useNavigate();

  const {
    setSelectedFile,
    initializePaymentSchema,
    setInitializePaymentSchema,
  } = useContext(GeneralContext);

  const { nceTranscriptInfo, setNceTranscriptInfo, setCopyType } = useContext(
    NCETranscriptRequestContext
  );

  const config = {
    email: nceTranscriptInfo.destinationEmail,
  };

  const closeHandler = () => {
    onClose((prevStep) => prevStep - 1);
  };

  const handleSubmission = () => {
    navigate("/dashboard/home");

    //resetting transcript state logic
    setNceTranscriptInfo({});
    setCopyType();
    setSelectedFile("");
    setInitializePaymentSchema({});
  };


  return (
    <>
      <PaymentGateway
        onPayment={handleSubmission}
        onPrevious={closeHandler}
        config={config}
        modal={modal}
        initializePaymentObject={initializePaymentSchema}
      />
    </>
  );
};
